module.exports = __webpack_public_path__ + "img/39.454d70d2.jpg";